import React from 'react';
import {OverlayTrigger} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import Tooltip from "react-bootstrap/Tooltip";
import {Placement} from "react-bootstrap/types";

interface ILoadingSpinnerProps {
    tooltipContent: string;
    placement?: Placement;
}

export const OverlayTooltip: React.FC<ILoadingSpinnerProps> = ({tooltipContent, placement}) => {
    const renderTooltip = (props: any) => (
        <Tooltip id="button-tooltip" {...props}>
            {tooltipContent}
        </Tooltip>
    );
    return (
        <OverlayTrigger
            trigger={["hover", "focus"]}
            placement={placement || "bottom"}
            delay={{show: 250, hide: 400}}
            overlay={renderTooltip}
        >
            <FontAwesomeIcon icon={faInfoCircle}/>
        </OverlayTrigger>
    )
};
